import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// ANNUAL_PHYSICAL_DELETE_ATTACHMENT

const mutation = gql`
  mutation annualPhysicalFormDeleteAttachment($id: ID!) {
    annualPhysicalFormDeleteAttachment(id: $id) {
      id
      form_attachment {
        id
      }
    }
  }
`
export default function useAnnualDeleteAttachment() {
  const { onMutate: onAnnualAttachmentDelete, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'annualPhysicalFormDeleteAttachment',
    successMessage: 'Attachment deleted'
  })

  return { onAnnualAttachmentDelete, loading }
}
